module.exports = __webpack_public_path__ + "my.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/my.svg
// module id = 718
// module chunks = 0